/* SAFA V14 · Maison */
(function () {
  'use strict';
  var reduce = !!(window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches);
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }

  function reveal() {
    var els = $$('[data-m-reveal]:not(.is-in)');
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    els.forEach(function (e) { io.observe(e); });
  }

  function header() {
    var h = document.querySelector('[data-m-header]');
    if (!h) return;
    function on() { h.classList.toggle('is-scrolled', window.scrollY > 8); }
    on();
    window.addEventListener('scroll', on, { passive: true });
    var t = h.querySelector('[data-nav-toggle]');
    if (t) t.addEventListener('click', function () {
      setTimeout(function () { document.documentElement.classList.toggle('m-nav-open', h.classList.contains('is-open')); }, 0);
    });
    h.querySelectorAll('[data-main-nav] a').forEach(function (a) { a.addEventListener('click', function () { document.documentElement.classList.remove('m-nav-open'); }); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && h.classList.contains('is-open')) { h.classList.remove('is-open'); document.documentElement.classList.remove('m-nav-open'); if (t) { t.setAttribute('aria-expanded', 'false'); t.focus(); } }
    });
  }

  function announce() {
    var track = document.querySelector('[data-m-announce]');
    if (!track) return;
    var items = $$('.m-announce__item', track);
    if (items.length < 2 || reduce) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4200);
  }

  function heroVideo() {
    $$('[data-m-autoplay]').forEach(function (v) {
      v.muted = true; v.defaultMuted = true; v.setAttribute('muted', '');
      function go() { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      go();
      v.addEventListener('canplay', go, { once: true });
      ['touchstart', 'scroll', 'click'].forEach(function (ev) { window.addEventListener(ev, function h() { if (v.paused) go(); window.removeEventListener(ev, h); }, { passive: true }); });
      document.addEventListener('visibilitychange', function () { if (!document.hidden && v.paused) go(); });
      if ('IntersectionObserver' in window) new IntersectionObserver(function (e) { if (e[0].isIntersecting) go(); else v.pause(); }).observe(v);
    });
  }

  function anchors() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href^="#"]');
      if (!a) return;
      var id = a.getAttribute('href').slice(1);
      var el = id && document.getElementById(id);
      if (!el) return;
      e.preventDefault();
      var top = el.getBoundingClientRect().top + window.scrollY - 76;
      window.scrollTo({ top: top, behavior: reduce ? 'auto' : 'smooth' });
    });
  }

  function init() { reveal(); header(); announce(); heroVideo(); anchors(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', reveal);
})();